/**
 * Dispara um evento standard do Meta Pixel (fbq). `eventId` é opcional —
 * quando definido, tem de ser o mesmo usado no evento equivalente do lado
 * do servidor (Conversions API) para a Meta deduplicar em vez de contar o
 * mesmo evento duas vezes.
 */
export function trackMetaEvent(
  eventName: string,
  params: Record<string, unknown> = {},
  eventId?: string,
): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return;
  }

  if (eventId) {
    window.fbq('track', eventName, params, { eventID: eventId });
  } else {
    window.fbq('track', eventName, params);
  }
}
